import * as React from 'react';

const PrinterChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="printer-chunky_svg__eds-icon--printer-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="printer-chunky_svg__eds-icon--printer-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.5 7V6h7v1h2V4h-11v3h2zm-5 1v8h3v4h11v-4h3V8h-17zm13 1h2v2h-2V9zm-1 9h-7v-6h7v6z"
        />
    </svg>
);

PrinterChunkySvg.displayName = 'PrinterChunkySvg';
export default PrinterChunkySvg;
